module.exports = __webpack_public_path__ + "img/img2.baedea2f.jpeg";